import { render, staticRenderFns } from "./MoveDialog.vue?vue&type=template&id=1a06967e&"
import script from "./MoveDialog.vue?vue&type=script&lang=js&"
export * from "./MoveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoveDialog.vue"
export default component.exports